import { useState } from "react";
import { useLocation } from "react-router-dom";
import { coachPaths } from "../../../routes/coach";
import ReserveYourSpot from "../../../components/Modals/common/reserve-your-spot";
import { pipViewDate, utcToLocalParts } from "../../../utils/pip";

const WorkShopViewDetails = ({ state }) => {
  const [isModal, setIsModal] = useState(false);
  const { pathname } = useLocation();
  const { date, time } = utcToLocalParts(state?.data?.schedule_date);

  const handleReserveYourSpot = (e) => {
    e.preventDefault();
    if (pathname == coachPaths?.CoachWork_shopDetail) {
      setIsModal(true);
    }
  };

  return (
    <>
      <section class="ct_workshop_banner_detail ct_px_40 mt-5 pb-4">
        <div class="container-fluid">
          <div class="row align-items-center ct_mb_100 pb-5">
            <div class="col-lg-7 mb-4 mb-lg-0">
              <div class="ps-lg-5">
                <h2
                  class="ct_fs_50 mb-3 ct_first_line_color ct_orange_text"
                  style={{ maxWidth: "681px" }}
                >
                  {state?.data?.section_1?.title ?? ""}
                </h2>
                <p class="mb-0 ct_fs_20" style={{ maxWidth: "681px" }}>
                  {state?.data?.section_1?.description ?? ""}
                </p>
                <div class="mt-4">
                  <a
                    class="ct_yellow_btn px-5 ct_fit_content"
                    onClick={handleReserveYourSpot}
                  >
                    Reserve Your Spot
                  </a>
                </div>
              </div>
            </div>
            <div class="col-lg-5 mb-4 mb-lg-0">
              <div className="position-relative ct_Authority_overlay_img_main">
                <label
                  class="ct_workshop_right_img w-100"
                  style={{ maxWidth: "340px" }}
                >
                  <img
                    src={
                      state?.data?.image1 != ""
                        ? (state?.data?.image1 ??
                          "/assets/img/Authority_img_111_new.png")
                        : "/assets/img/Authority_img_111_new.png"
                    }
                    alt=""
                    className="ct_img_h_458"
                  />
                </label>
                <label class="ct_workshop_right_img">
                  <img
                    src={
                      state?.data?.image2 != ""
                        ? (state?.data?.image2 ??
                          "/assets/img/Authority_img_112_new.png")
                        : "/assets/img/Authority_img_112_new.png"
                    }
                    alt=""
                    className="ct_img_h_328"
                  />
                </label>
              </div>
            </div>
          </div>
          <div class="d-lg-flex  align-items-center justify-content-around gap-3 mt-5 pb-3 ct_mt_3_1326 ct_grid_2_991_new pt-5">
            <label className="mb-0 d-flex align-items-center gap-1  ct_text_op_8 ct_fs_24 ct_outline_blue_5 ct_ms_minus_55">
              {pipViewDate(date)}
              {"  "}
              {time}
            </label>
            <div
              class="ct_text_op_8 ct_fs_24  d-flex align-items-start gap-4 ct_para_scroll ct_custom_scroll"
              style={{ maxWidth: "250px", maxHeight: "50px" }}
            >
              <img
                src="/assets/img/location_icon_big_new.png"
                className="ct_icon_30"
              />{" "}
              <span className="mt-0">{state?.data?.location ?? ""}</span>
            </div>
            <div
              class="ct_text_op_8 ct_fs_24  d-flex align-items-center gap-4 ct_para_scroll ct_custom_scroll"
              style={{ maxWidth: "250px", maxHeight: "50px" }}
            >
              <img src="/assets/img/globe_icon.png" className="ct_icon_30" />{" "}
              {state?.data?.language ?? ""}
            </div>
            <div
              class="ct_text_op_8 ct_fs_24   d-flex align-items-center gap-4 ct_para_scroll ct_custom_scroll"
              style={{ maxWidth: "250px", maxHeight: "50px" }}
            >
              <img
                src="/assets/img/clock_new_icxon_22.png"
                className="ct_icon_30"
              />
              {state?.data?.hours ?? ""}
            </div>
          </div>
        </div>
      </section>

      <section className="ct_pt_127_pb_97 ct_px_40 ct_light_sky_blue_bg">
        <div className="row align-items-center">
          <div className="col-xxl-5 col-xl-5  mb-4 mb-xl-0">
            <div className="ct_leadership_work_aaspect_ratio_991">
              <img src="../assets/img/img_5480.png" className="ct_img_h_531" />
            </div>
          </div>
          <div className="col-xxl-7 col-xl-7  mb-4 mb-md-0 ps-md-5">
            <h4 className="ct_fs_32 ct_darksky_blue_text mb-2">
              {state?.data?.section_2?.title ?? ""}
            </h4>
            <p
              className="ct_orange_text mb-4 ct_fs_20"
              style={{ maxWidth: "849px" }}
            >
              {state?.data?.section_2?.subtitle ?? ""}
            </p>
            <ul>
              <li>
                <p className="mb-0 ct_fs_20" style={{ maxWidth: "770px" }}>
                  {state?.data?.section_2?.description ?? ""}
                </p>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {state?.data?.speakers?.length != 0 &&
      state?.data?.speakers?.length == 1 ? (
        <section
          class="ct_coach_created_bg mt-0 ct_py_100"
          style={{ backgroundColor: "#ffb80533" }}
        >
          <div class="container">
            <div class="row">
              <div class="col-lg-4  mb-4 mb-lg-0">
                <label class="ct_learn_img d-block">
                  <img
                    src={
                      state?.data?.speakers[0]?.image ??
                      "/assets/img/meet_nellie_img.png"
                    }
                    alt=""
                    style={{ height: "400px" }}
                  />
                </label>
              </div>
              <div class="col-lg-8 mb-4 mb-lg-0 ps-lg-5">
                <div class="d-flex align-items-end gap-3 ct_flex_col_575">
                  <div>
                    <h4 class="ct_fs_28 ct_orange_text mb-4">
                      {state?.data?.speakers[0]?.name ?? ""}
                    </h4>
                    <p class="ct_fs_22 mb-0">
                      {state?.data?.speakers[0]?.role ?? ""}
                    </p>
                    <div class="mt-4">
                      <p class="ct_fs_20 mb-3" style={{ maxWidth: "545px" }}>
                        {state?.data?.speakers[0]?.sub_role ?? ""}
                      </p>
                    </div>
                    <div class="mt-5">
                      <a class="ct_yellow_btn ct_orange_bg ct_fit_content px-5 mx-auto">
                        View My Profile
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      ) : (
        <section class=" mt-0 ct_py_100">
          <div class="container">
            <div class="row">
              <div class="col-md-12">
                <h2 class="ct_darksky_blue_text text-center ct_fs_44 ct_fw_600 pb-5">
                  Speakers
                </h2>
              </div>
            </div>
            <div class="row ct_px_40 justify-content-between">
              {state?.data?.speakers?.map((item, i) => (
                <div class="col-xl-3 col-lg-3 mb-5 ">
                  <div className="position-relative">
                    <div class="ct_speakers_card">
                      <label class="ct_speaker_img d-block mx-auto">
                        <img
                          src={item?.image ?? "/assets/img/meet_nellie_img.png"}
                          alt=""
                        />
                      </label>
                      <div class="ct_about_speaker text-center">
                        <h4 class="ct_fs_32 ct_fw_600 mb-2 ct_blue_text">
                          {item?.name ?? ""}
                        </h4>
                        <p class="ct_fs_16">{item?.role ?? ""}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      <section
        class="ct_looking_for_work_bg ct_mt_100  ct_p_111_y_106 ct_looking_for_work_bg_left"
        style={{ backgroundColor: "#219EBC" }}
      >
        <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
          <div class="text-white">
            <h4 class="ct_fs_36 mb-4">
              Built For Founders. Backed by Experience
            </h4>
            <p class="mb-0 ct_fs_18">
              We’ve designed this workshop to deliver clear direction, not just
              inspiration.
            </p>
          </div>
          <div class="ct_flex_shrink_0">
            <a
              class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
              onClick={handleReserveYourSpot}
            >
              Reserve Your Spot
            </a>
          </div>
        </div>
      </section>

      <section class="ct_py_100 ct_px_100">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12">
              <h2 class="ct_fs_40 ct_darksky_blue_text text-center mb-3 ct_fw_600">
                {state?.data?.section_3?.title ?? ""}
              </h2>
              <p
                class="mb-0 ct_fs_24 text-center mx-auto"
                style={{ maxWidth: "684px" }}
              >
                {state?.data?.section_3?.description ?? ""}
              </p>
            </div>
          </div>
          <div class="row mt-5 pt-3">
            <div class="col-lg-4 mb-4 mb-lg-0">
              <div
                class="ct_what_learn_card mb-4"
                style={{ backgroundColor: "#F7F7F7" }}
              >
                <div>
                  <h4 class="ct_fs_24 mb-2">
                    {state?.data?.section_3?.cards[0]?.title}
                  </h4>
                  <p
                    class="mb-0 ct_grey_text ct_para_scroll ct_custom_scroll"
                    style={{ maxHeight: "77px" }}
                  >
                    {state?.data?.section_3?.cards[0]?.description}
                  </p>
                </div>
                <div class="ct_mt_20  d-flex justify-content-end">
                  <a class="ct_top_right_arrow_icon">
                    <img src="/assets/img/right_top_arrow.svg" alt="" />
                  </a>
                </div>
              </div>
              <div
                class="ct_what_learn_card mb-4"
                style={{ backgroundColor: "#EDF6F9" }}
              >
                <div>
                  <h4 class="ct_fs_24 mb-2">
                    {state?.data?.section_3?.cards[2]?.title}
                  </h4>
                  <p
                    class="mb-0 ct_grey_text ct_para_scroll ct_custom_scroll"
                    style={{ maxHeight: "77px" }}
                  >
                    {state?.data?.section_3?.cards[2]?.description}
                  </p>
                </div>
                <div class="ct_mt_20  d-flex justify-content-end">
                  <a class="ct_top_right_arrow_icon">
                    <img src="/assets/img/right_top_arrow.svg" alt="" />
                  </a>
                </div>
              </div>
            </div>
            <div class="col-lg-4 mb-4 mb-lg-0">
              <label class="ct_learn_img w-100">
                <img src="/assets/img/Rectangle 3.png" alt="" />
              </label>
            </div>
            <div class="col-lg-4 mb-4 mb-lg-0">
              <div
                class="ct_what_learn_card mb-4"
                style={{ backgroundColor: "#ffb80526" }}
              >
                <div>
                  <h4 class="ct_fs_24 mb-2">
                    {state?.data?.section_3?.cards[1]?.title}
                  </h4>
                  <p
                    class="mb-0 ct_grey_text ct_para_scroll ct_custom_scroll"
                    style={{ maxHeight: "77px" }}
                  >
                    {state?.data?.section_3?.cards[1]?.description}
                  </p>
                </div>
                <div class="ct_mt_20  d-flex justify-content-end">
                  <a class="ct_top_right_arrow_icon">
                    <img src="/assets/img/right_top_arrow.svg" alt="" />
                  </a>
                </div>
              </div>
              <div
                class="ct_what_learn_card mb-4"
                style={{ backgroundColor: "#F5F3EF" }}
              >
                <div>
                  <h4 class="ct_fs_24 mb-2">
                    {state?.data?.section_3?.cards[3]?.title}
                  </h4>
                  <p
                    class="mb-0 ct_grey_text ct_para_scroll ct_custom_scroll"
                    style={{ maxHeight: "77px" }}
                  >
                    {state?.data?.section_3?.cards[3]?.description}
                  </p>
                </div>
                <div class="ct_mt_20  d-flex justify-content-end">
                  <a class="ct_top_right_arrow_icon">
                    <img src="/assets/img/right_top_arrow.svg" alt="" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        class="ct_py_90 ct_light_sky_bg "
        style={{ backgroundColor: "hsl(43deg 100% 51% / 21%)" }}
      >
        <div class="container">
          <div class="row">
            <div class="col-md-12 mb-4">
              <h2
                class="ct_fs_32 mb-3 ct_fw_600 text-center "
                style={{ color: "#FFB703" }}
              >
                {state?.data?.section_4?.title ?? ""}
              </h2>
              <p class="mb-0  text-center ct_fs_20">
                {state?.data?.section_4?.description ?? ""}
              </p>
            </div>
          </div>
          <div class="row ct_pt_60">
            <div class="col-md-4 mb-4 mb-md-0">
              <div class="ct_glance_card text-center">
                <figure class="mb-0">
                  <div class="ct_glance_icon mb-3">
                    <img
                      src="/assets/img/line-md_calendar.png"
                      alt=""
                      className="ct_w_50_340"
                    />
                  </div>
                  <figcaption class="text-center">
                    <h4 class="ct_fs_24 mb-3 ct_darksky_blue_text ct_fw_600">
                      Date & Time
                    </h4>
                    <p className="ct_fs_18 ct_line_h_30  mb-0">
                      <span className="ct_white_nowrap">Date: </span>
                      <label>{pipViewDate(date) || ""}</label>
                    </p>
                    <p className="ct_fs_18 ct_line_h_30  mb-0">
                      <span className="ct_white_nowrap">Time: </span>
                      <label>{time || ""}</label>
                    </p>
                    <p className="ct_fs_18 ct_line_h_30  mb-0">
                      <span className="ct_white_nowrap">Duration: </span>
                      <span>
                        {" "}
                        {state?.data?.section_4?.cards[0]?.text_2 || ""}
                      </span>
                    </p>
                  </figcaption>
                </figure>
              </div>
            </div>
            <div class="col-md-4 mb-4 mb-md-0">
              <div class="ct_glance_card text-center">
                <figure class="mb-0">
                  <div class="ct_glance_icon mb-3">
                    <img
                      src="/assets/img/locationLogo.png"
                      alt=""
                      className="ct_w_50_340"
                    />
                  </div>
                  <figcaption class="text-center">
                    <h4 class="ct_fs_24 mb-3 ct_darksky_blue_text ct_fw_600">
                      Location
                    </h4>
                    <p className="ct_fs_18 ct_line_h_30   mb-0">
                      <span className="ct_white_nowrap">Format: </span>
                      <span>
                        {" "}
                        {state?.data?.section_4?.cards[1]?.title || ""}
                      </span>
                    </p>
                    <p className=" ct_fs_18 ct_line_h_30   mb-0">
                      <span className="ct_white_nowrap">Price: </span> Rs
                      <span>
                        {state?.data?.section_4?.cards[1]?.text_1 || ""}{" "}
                      </span>
                    </p>
                    <p className=" ct_fs_18 ct_line_h_30   mb-0">
                      <span className="ct_white_nowrap">Bonus: </span>
                      <span>
                        {" "}
                        {state?.data?.section_4?.cards[1]?.text_2 || ""}
                      </span>
                    </p>
                  </figcaption>
                </figure>
              </div>
            </div>
            <div class="col-md-4 mb-4 mb-md-0">
              <div class="ct_glance_card text-center">
                <figure class="mb-0">
                  <div class="ct_glance_icon mb-3">
                    <img
                      src="/assets/img/file.png"
                      alt=""
                      className="ct_w_50_340"
                    />
                  </div>
                  <figcaption class="text-center">
                    <h4 class="ct_fs_24 mb-3 ct_darksky_blue_text ct_fw_600">
                      What You’ll Need
                    </h4>
                    <p class="mb-0 ct_fs_18 text-center mx-auto ct_line_h_30">
                      {state?.data?.section_4?.cards[2]?.title || ""}
                    </p>
                  </figcaption>
                </figure>
              </div>
            </div>
          </div>

          <div class="text-center ct_mt_40">
            <button
              class="ct_yellow_btn ct_sky_blue_btn px-5 mx-auto"
              onClick={handleReserveYourSpot}
            >
              Reserve Your Spot
            </button>
          </div>
        </div>
      </section>

      <section class=" ct_px_40 pt-0 ct_mt_100">
        <div class="container-fluid">
          <div class="row align-items-center">
            <div class="col-xxl-7 col-xl-6 col-md-6 mb-4 mb-md-0">
              <div class="ct_about_cnt">
                <h2 class="mb-4 ct_fs_32 mb-5 ">Frequently asked questions</h2>
                <div class="ct_faq_question_main ct_faq_question_yellow_plus">
                  <div class="accordion" id="faq_accordionExample">
                    {state?.data?.section_5?.map((item, i) => (
                      <div className="d-flex align-items-center gap-2">
                        <div class="accordion-item ct_flex_1">
                          <h2 class="accordion-header" id="faq_one">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target={`#collapsefaq_one${i}`}
                              aria-expanded="false"
                              aria-controls={`collapsefaq_one${i}`}
                            >
                              {item?.question != ""
                                ? item?.question
                                : "Enter Question"}
                            </button>
                          </h2>
                          <div
                            id={`collapsefaq_one${i}`}
                            class="accordion-collapse collapse"
                            aria-labelledby="faq_one"
                            data-bs-parent="#faq_accordionExample"
                          >
                            <div class="accordion-body">
                              <p class="ct_fs_20 mb-3 ct_line_h_30">
                                {item?.answer != ""
                                  ? item?.answer
                                  : "Enter Answer"}
                              </p>
                            </div>
                          </div>
                        </div>
                        {state?.data?.section6?.faqs?.length > 1 && (
                          <div className="mt-3 ct_cursor_pointer">
                            <i class="fa-solid fa-trash-can text-danger"></i>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xxl-4  col-xl-6 col-md-6 mb-4 mb-md-0 ps-md-5">
              <label class="ct_about_img">
                <img
                  src={state?.data?.faqimage || "/assets/img/faq_6789.png"}
                  class="ct_img_h_617"
                  alt=""
                />
              </label>
            </div>
          </div>
        </div>
      </section>

      <section
        class="ct_looking_for_work_bg ct_mt_100 ct_p_111_y_106 mb-5"
        style={{ backgroundColor: "#F58220" }}
      >
        <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
          <div class="text-white">
            <h4 class="ct_fs_36 mb-4" style={{ maxWidth: "640px" }}>
              Ready to Join Us Live?
            </h4>
            <p class="mb-0 ct_fs_18" style={{ maxWidth: "619px" }}>
              Spaces are limited reserve your seat and walk away with clarity,
              strategy, and momentum{" "}
            </p>
          </div>
          <div class="ct_flex_shrink_0">
            <a class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5">
              View More
            </a>
          </div>
        </div>
      </section>

      {pathname == coachPaths?.CoachWork_shopDetail && isModal && (
        <ReserveYourSpot
          data={state?.data || {}}
          setIsModal={setIsModal}
          page={"workshop"}
        />
      )}

      <div style={{ height: "100px" }}></div>
    </>
  );
};

export default WorkShopViewDetails;
